export default __webpack_public_path__ + "static/media/right_arrow_icon.75b034b8.svg";